export default {
  ROUTES_REQUEST: 'ROUTES_REQUEST',
  ROUTES_SUCCESS: 'ROUTES_SUCCESS',
  ROUTES_FAILURE: 'ROUTES_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/RoutesConstants.js